import httpClient from './httpClient'

const MasterApi = {
  async fetchBrandList({ pageSize, pageNo, name, url }) {
    try {
      const params = {
        page_size: pageSize,
        page_no: pageNo,
        name: name,
        url: url,
      }
      const res = await httpClient.get('/master/brand', { params: params })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchCategoryList({ pageSize, pageNo, name }) {
    try {
      const params = {
        page_size: pageSize,
        page_no: pageNo,
        name: name,
      }
      const res = await httpClient.get('/master/category', { params: params })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchRailwayCompanyList({ pageSize, pageNo, name }) {
    try {
      const params = {
        page_size: pageSize,
        page_no: pageNo,
        name: name,
      }
      const res = await httpClient.get('/master/railway/company', {
        params: params,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchRailwayLineList({ pageSize, pageNo, companyId, name }) {
    try {
      const params = {
        page_size: pageSize,
        page_no: pageNo,
        company_id: companyId,
        name: name,
      }
      const res = await httpClient.get('/master/railway/line', {
        params: params,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchRailwayStationList({ pageSize, pageNo, companyId, lineId, name }) {
    try {
      const params = {
        page_size: pageSize,
        page_no: pageNo,
        company_id: companyId,
        line_id: lineId,
        name: name,
      }
      const res = await httpClient.get('/master/railway/station', {
        params: params,
      })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchRegionList({ pageSize, pageNo, countryId, name }) {
    try {
      const params = {
        page_size: pageSize,
        page_no: pageNo,
        country_id: countryId,
        name: name,
      }
      const res = await httpClient.get('/master/region', { params: params })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchCityList({ pageSize, pageNo, regionId, name }) {
    try {
      const params = {
        page_size: pageSize,
        page_no: pageNo,
        region_id: regionId,
        name: name,
      }
      const res = await httpClient.get('/master/city', { params: params })
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchIpAreaCountryList() {
    return await httpClient.get(`/master/ip_area/country`)
  },
  async fetchIpAreaRegionList({ countryId }) {
    const params = {
      country_id: countryId,
    }
    const res = await httpClient.get(`/master/ip_area/region`, {
      params,
    })
    return res.data
  },
  async fetchLargeClassification() {
    try {
      const res = await httpClient.get('/master/industry_classification/large')
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async fetchCtaList() {
    try {
      const res = await httpClient.get('/master/cta')
      return res.data.items
    } catch (e) {
      console.log(e)
    }
  },
  async fetchSmallClassification({ pageSize, pageNo, sectorCode, name }) {
    try {
      const params = {
        page_size: pageSize,
        page_no: pageNo,
        sector_code: sectorCode,
        name: name,
      }
      const res = await httpClient.get(
        '/master/industry_classification/middle',
        { params: params },
      )
      return res.data
    } catch (e) {
      console.log(e)
    }
  },
  async isHideRevenue(advertiserId) {
    try {
      const res = await httpClient.get(
        `/master/hide_revenue_clients/isIncluded?advertiser_id=${advertiserId}`,
      )
      return res.data
    } catch (e) {
      console.log(e, 'error of masterApi.isHideRevenue')
      throw e
    }
  },
}

export default MasterApi
